import Auth from './Auth/Auth'

import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './Routes'

const App = () => {
  return (
    <BrowserRouter>
      <Auth />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
